const React = window.React;

export function removeFormForSubmit(){
    document.getElementById( 'digioh-form-wrapper' )?.remove();
}

export function setFormVisibility(visible = true){
    const elForm = document.querySelector( '#lightbox-inline-webinar-form' );
    if( elForm ){
        elForm.style.opacity = visible ? '1' : '0';
    }
}

/**
 * Get the lightbox name from the DIGIOH_LIGHTBOX_CONDITIONS global variable based on the provided selector value.
 * @param {string} v 
 * @returns {string|null}
 */
export function getLightboxNameFromSelector(v) {
        const match = DIGIOH_LIGHTBOX_CONDITIONS.find(item => {
        if (!item.conditions || !Array.isArray(item.conditions)) return false;

            return item.conditions.some(group =>
                Array.isArray(group) &&
                group.some(cond => cond.v && cond.v.includes(v))
            );
        });

        if (!match) return null;

        const guid = match.lightbox_guid;

        const name = window.DIGIOH_LIGHTBOX_NAMES[guid] || null;

        return name;
	}

export default function regKey(){
    if( adw?.webinar_meta?.registration_url ){
        return "aw_webinar_" + btoa( adw.webinar_meta.registration_url );
    } else if( adw?.webinar_meta?.event_id ){
        return "aw_webinar_" + btoa( adw.webinar_meta.event_id );
    }
    return null;
}

export async function registerUserOnZephr( {fieldValues, email, password} ){
    const user = {
        identifiers: {
            email_address: email
        },
        attributes: fieldValues
    };

    if( password ){
        user['validators'] = {
            password: password
        }
    }

    const response = await fetch( `${window.location.origin}/blaize/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
        body: JSON.stringify(user),
    } );
    const data = await response.json();

    return {
        ...data,
        ok: response.ok,
        status: response.status || data?.status,
    };
}

export async function checkZephrUserExists( email ){
    const body = new URLSearchParams({
        action: 'adw_zephr_check_user_email_exist',
        email,
    });
    const response = await fetch( window.zephr_object.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: body.toString(),
    } );

    if( !response.ok ){
        throw new Error(`Zephr User existence check failed with status ${response.status}`);
    }

    const result = await response.json();
    if( typeof result?.success !== 'boolean' ){
        throw new Error('Zephr User existence check returned an invalid response');
    }

    return result.success;
}

export async function startPasswordlessAuthOnZephr( {email, action = 'login'} ){
    try{
        const response = await fetch( `${window.location.origin}/blaize/token-exchange`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify({
                "identifiers": {
                    "email_address": email
                },
                "delivery": {
                    "method": "email",
                    "destination": email,
                    "action": action,
                    "redirect": window.location.href
                }
            }),
            credentials: 'include',
        } );

        if( !response.ok ){
            throw new Error(`Zephr token exchange failed with status ${response.status}`);
        }

        return response;
    } catch ( err ){
        console.error("Error in Zephr Passwordless Auth", err);
        throw err;
    }
}

// Set local storage value
export const setRegStatusLocalStorage = ( email = '', unset = false ) => {
    const localStorageKey = regKey();
    if( unset ){
        localStorage.removeItem( localStorageKey );
    } else {
        localStorage.setItem( localStorageKey, JSON.stringify( btoa( email ) ) );
    }
};

// Get local storage value
export const getRegStatusLocalStorage = ( ) => {
    const localStorageKey = regKey();
    if( !localStorageKey ) return false;
    const localStorageValue = localStorage.getItem( localStorageKey );
    if( localStorageValue ){
        return JSON.parse( atob( localStorageValue ) );
    }
    return false;
}

export const setRegStatusCookies = ( email ) => {
    if( typeof Cookies === 'function' ){
        const cookieKey = regKey();
        if( !cookieKey ) throw new Error('No cookie key available');
        Cookies.set( cookieKey, JSON.stringify( btoa( email ) ), { expires: 30 } );
    }
};
export const getRegStatusCookies = ( ) => {
    if( typeof Cookies === 'function' ){
        const cookieKey = regKey();
        if( !cookieKey ) throw new Error('No cookie key available');
        const cookieValue = Cookies.get( cookieKey );
        if( cookieValue ){
            return atob( JSON.parse( cookieValue ) );
        }
    }
    return false;
};

export const getRegStatusClientSide = ( ) => {
    return( getRegStatusCookies() || getRegStatusLocalStorage() );
}

export const setRegStatusClientSide = ( email = '' ) => {

    setRegStatusCookies( email );
    setRegStatusLocalStorage( email );
    adw.webinar_meta.is_registered = true
}

export const registerUserForWebinar = function( args, postId = null ){
    
    return new Promise( (resolve, reject) => {

        const params = new URLSearchParams();
        for( const key in args ){
            params.set( key, args[key] );
        }

        // Add post ID to params if available
        if( postId ){
            params.set( 'post_id', postId );
        }

        const queryString = params.toString();

        // If registration_url is set in post meta, use the new default registration flow
        const registrationUrl = adw?.webinar_meta?.registration_url;

        if( registrationUrl ){
            const {
                fname,
                lname,
                email,
                firstName,
                lastName,
                emailAddress,
                ...additionalFields
            } = args;

            const registrationPayload = {
                firstName: firstName || fname || '',
                lastName: lastName || lname || '',
                emailAddress: emailAddress || email || '',
                ...additionalFields,
            };

            const requestPayload = {
                ...registrationPayload,
                post_id: Number( postId || adw?.post?.id || 0 ),
                registration_url: registrationUrl,
            };

            fetch( `${window.location.origin}/wp-json/adw_webinar_registration/v1/registration/`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify( requestPayload ),
            } )
                .then(response => {
                    return response?.json?.() || {};
                }).then( response => {
                    return resolve( response )
                })
                .catch(error => reject( error ));
            
        } else {

            // To-Do: Remove this legacy registration flow after confirming all clients have updated to the new flow that uses the registration_url post meta field
            fetch( `${window.location.origin}/wp-json/adw-webcasts/v1/register_user/?${queryString}` )
                .then(response => {
                    if( response.status !== 200 ){
                        return reject();
                    }
                    const contentType = response.headers.get( 'content-type' ) || '';
                    if( contentType.includes( 'application/json' ) ){
                        return response.json();
                    }

                    return response.text().then( text => {
                        try {
                            return JSON.parse( text );
                        } catch ( err ) {
                            return text;
                        }
                    } );
                })
                .then( response => resolve( response ) )
                .catch(error => reject( error ));
        }

        // Send data to BigQuery
        sendRegistrationDataToBigQuery( queryString );

    } )
};

function isProductionDomain() {
    const host = window.location.host;
    return host === "www.adweek.com" || host === "adweek.com";
}

function buildIterableEndpoint(path) {
    const base = isProductionDomain()
        ? "https://audience.adweek.com"
        : "https://audience-develop.adweek.com";

    return base + path;
}

export const sendRegistrantToIterable = function( args ){

	const endpoint = buildIterableEndpoint('/wp-json/adw-zephr/v2/webinar-registration-to-iterable');

	if(!endpoint){
		throw new Error('No iterable endpoint');
	}

	return new Promise( (resolve, reject) => {

		fetch(endpoint, {
			method: 'POST',
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(args),
		})
			.then(response => {

				if (response.status !== 200) {
					return reject();
				}

				return response.json();
			})
			.then(response => resolve(response))
			.catch(error => reject(error));

    }).catch((error) =>
        console.error(
            "sendDataToIterable: failed to POST data to Iterable endpoint",
            { endpoint, payload: args },
            error,
        ),
    );
};

function sendRegistrationDataToBigQuery( queryString ){
    if( !( adw?.webinar_meta?.bigquery_webhook ) ) return;
    return fetch( `${adw.webinar_meta.bigquery_webhook}/?${queryString}` )
        .then(response => {
            if( response.status !== 200 ){
                return reject();
            }
            console.log( response );
        })
        .catch(error => console.error( 'Error in BigQuery Webhook', error ));
}

export const getEnterTheWebinarLink = ( {email} ) => {

    if( !email ) return ``;

    if( adw?.webinar_meta?.registration_url ){
        return `${adw.webinar_meta.auto_join_url}?emailAddress=${email}`;
    }

    // To-Do: Update this function to use the registration_url post meta field for generating the webinar entry link if it's set, and remove legacy support for the old entry link format that relies on the event_id query param after confirming all clients have updated to the new flow 
    return `https://event.webcasts.com/starthere.jsp?ei=${adw.webinar_meta.event_id}&email=${email}`;
}

export const useAnimIn = ( ref, options = {} ) => {
    React.useEffect( () => {

        if( typeof anime === 'function' && ref?.current !== 'undefined' ){

            anime( {
                targets: ref.current,
                opacity: [0, 1],
                translateY: [10, 0],
                duration: 500,
                easing: 'easeOutQuad',
                ...options,
                complete: function( anim ){

                }
            } )
        }
    }, [ref] );
}

/**
 * The localStorage listeners
 * @type {Map<string, Set<() => void>>}
 */
const localStorageListeners = new Map();

/**
 * Notify the localStorage listeners
 * @param {string} key - The key to notify the listeners
 */
function notifyLocalStorageListeners (key) {
    localStorageListeners.get(key)?.forEach(cb => cb());
}

/**
 * Get the value from the localStorage with a boolean check
 * @param {any} val - The value to check
 * @returns {any} The value from the localStorage
 */
function getValWithBoolCheck (val) {
    if (val === 'true' || val === 'false') return val === 'true';
    return val;
}

/**
 * Custom hook to manage client-side state using localStorage
 * @param {string} key - The key to store the state in localStorage
 * @param {any} defaultVal - The default value to return if the state is not found in localStorage
 * @returns {[any, (newVal: any) => void]} An array with the current state and a function to update the state
 */
export function useStateWithClientStorage (key, defaultVal) {
    const defaultValRef = React.useRef(defaultVal);

    const subscribe = React.useCallback((callback) => {
        const listeners = localStorageListeners.get(key)
            ?? localStorageListeners.set(key, new Set()).get(key);
        listeners.add(callback);

        const handler = (e) => {
            if (e.key === key || e.key === null) callback();
        };
        window.addEventListener('storage', handler);

        return () => {
            localStorageListeners.get(key)?.delete(callback);
            window.removeEventListener('storage', handler);
        };
    }, [ key ]);

    const getSnapshot = React.useCallback(
        () => localStorage.getItem(key),
        [ key ]
    );

    const raw = React.useSyncExternalStore(subscribe, getSnapshot);

    const value = React.useMemo(() => {
        if (raw === null) return defaultValRef.current;
        try {
            return getValWithBoolCheck(JSON.parse(raw));
        } catch {
            return defaultValRef.current;
        }
    }, [ raw ]);

    const setValue = React.useCallback((newVal) => {
        try {
            localStorage.setItem(key, JSON.stringify(newVal));
            notifyLocalStorageListeners(key);
        } catch (e) {
            console.warn(`useStateWithClientStorage: failed to write key "${key}"`, e);
        }
    }, [ key ]);

    return [ value, setValue ];
}

export const useMinheight = ( ref ) => {
    React.useEffect( () => {

        if( ref.current ){
            const elHeight = ref.current.getBoundingClientRect().height;

            if( typeof elHeight === 'number' && elHeight > 0 ){
                ref.current.style.minHeight = `${elHeight}px`;
            }
        }
    }, [ref] );
}
